import React, { useState } from 'react';
import {
  convertMB2Byte,
  DropZoneHelperText,
  FileConfig,
  getInitialFiles,
  Grid,
  CustomDropZone,
} from 'web-library';
import { UploadedFile } from 'web-library/models/UploadedFile';

import { useDeleteRequestFile } from '../../api-refactored/user-group-access-configuration/useDeleteRequestFile';
import { handleFileDelete } from '../../pages/accessArrangement/SelectCondition/components/UploadDocuments/components/useUploadFile';
import AttachedFiles from '../upload-documents/AttachedFiles';

interface FileDropZoneProps {
  fileConfig: FileConfig;
  files: UploadedFile[];
  setFiles: React.Dispatch<React.SetStateAction<UploadedFile[]>>;
  isLoading: boolean;
  submittedFiles?: number;
  draftFiles?: UploadedFile[];
  setDraftFiles?: React.Dispatch<React.SetStateAction<UploadedFile[]>>;
  isEditable?: boolean;
}

export const RequestFileDropZone = ({
  fileConfig,
  files,
  setFiles,
  draftFiles,
  setDraftFiles,
  submittedFiles,
  isLoading,
  isEditable = true,
}: FileDropZoneProps) => {
  const [dropzoneKey, setDropzoneKey] = useState<string>('');

  const { mutate: deleteFileMutate } = useDeleteRequestFile();

  const onUploadFileDelete = async (file: File, isDraft = false) => {
    if (isDraft && draftFiles && setDraftFiles) {
      handleFileDelete(file, draftFiles, setDraftFiles, deleteFileMutate);
    } else {
      handleFileDelete(file, files, setFiles, deleteFileMutate);
    }

    setDropzoneKey(Date.now().toString());
  };

  const onFileUpload = (uploadedFiles: File[]) => {
    setFiles(
      uploadedFiles.map((file) => ({
        file,
        uploaded: false,
        hasError: false,
        pending: false,
      }))
    );
  };

  const initialFiles = getInitialFiles(files);

  return (
    <>
      <Grid xs={12} sm={12} md={12} lg={12}>
        <CustomDropZone
          filesLimit={isEditable ? fileConfig.fileNumLimit : 0}
          acceptedFiles={fileConfig.uploadFileTypes}
          maxSize={convertMB2Byte(fileConfig.fileSizeLimit)}
          key={dropzoneKey}
          initialFiles={initialFiles}
          onChange={onFileUpload}
          onDelete={onUploadFileDelete}
        />
        <DropZoneHelperText
          acceptedFileTypes={fileConfig.uploadFileTypes}
          fileLimit={fileConfig.fileNumLimit}
          fileSizeLimit={fileConfig.fileSizeLimit}
        />
      </Grid>

      <AttachedFiles
        files={files}
        setFiles={setFiles}
        onUploadFileDelete={onUploadFileDelete}
        draftFiles={draftFiles}
        isLoading={isLoading}
        downloadableLink
      />
    </>
  );
};
